import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Page, PageHeader } from '../../ui';
import { api } from '../../ui/api';
import ServiceForm from './ServiceForm';

const AddService = () => {
  const navigate = useNavigate();
  const save = async (payload) => {
    await api('/service/add', { method: 'POST', body: payload });
    navigate('/manage-services');
  };
  return (
    <Page>
      <PageHeader title="Add service" back={{ to: '/manage-services', label: 'Services' }} />
      <ServiceForm onSave={save} submitLabel="Publish service" />
    </Page>
  );
};

export default AddService;
